import React from 'react';
import moment from 'moment';
import placeholder from '../../assets/styles/img/img-placeholder-full-width.png';

const PreviewSermonsItem = (props) => {
    return (
        <div className="sermons-item">
            <div className="sermons-item-thumbnail">
                <img src={props.item.thumbnailImage ? props.item.thumbnailImage : placeholder} />
            </div>
            <div className="sermons-item-info">
                <h4 className="sermons-item-title" style={{ color: props.primaryText }}>
                    {props.item.title}
                </h4>
                <p className="sermons-timeago">
                    {moment(props.item.date).format('MMM D')}
                </p>
            </div>
        </div>
    );
};

export default PreviewSermonsItem;
